export default __webpack_public_path__ + "static/media/guardian.bf89153b.png";